import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function FinalCTASection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-25">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-16" data-id="element-26">
        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-8" data-id="element-27">
          TOMÁ LA DECISIÓN CORRECTA HOY
        </h2>

        <div className="max-w-3xl mx-auto text-lg text-slate-300 space-y-4 mb-10 text-left bg-slate-900/50 p-8 rounded-xl border border-slate-800" data-id="element-28">
          <p className="font-bold text-white mb-4" data-id="element-29">
            Cada semana que pasa sin un sistema organizacional es una semana en
            que:
          </p>
          <ul className="space-y-3" data-id="element-30">
            <li className="flex items-start gap-2" data-id="element-31">
              <span className="text-red-500" data-id="element-32">✦</span> Tu empresa sigue
              dependiendo de tu presencia constante
            </li>
            <li className="flex items-start gap-2" data-id="element-33">
              <span className="text-red-500" data-id="element-34">✦</span> Los errores que podrían
              prevenirse se siguen repitiendo
            </li>
            <li className="flex items-start gap-2" data-id="element-35">
              <span className="text-red-500" data-id="element-36">✦</span> El talento que podrías
              retener se va porque no hay claridad en los roles
            </li>
            <li className="flex items-start gap-2" data-id="element-37">
              <span className="text-red-500" data-id="element-38">✦</span> Los proyectos que podrían
              entregarse a tiempo se siguen atrasando
            </li>
            <li className="flex items-start gap-2" data-id="element-39">
              <span className="text-red-500" data-id="element-40">✦</span> Las decisiones que podrían
              tomarse con datos se siguen tomando con intuición
            </li>
          </ul>
        </div>

        <p className="text-2xl font-bold text-amber-500 mb-4" data-id="element-41">
          El costo de no actuar siempre es mayor que el costo de invertir.
        </p>
        <p className="text-xl text-slate-300 mb-2" data-id="element-42">
          La pregunta no es si podés permitirte profesionalizar tu empresa.
        </p>
        <p className="text-2xl font-extrabold text-white" data-id="element-43">
          La pregunta es si podés permitirte no hacerlo.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-44">
        <h3 className="text-3xl font-bold text-center text-white mb-12 border-b-2 border-slate-800 pb-4 inline-block mx-auto w-full" data-id="element-45">
          ELEGÍ TU NIVEL AHORA
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-46">
          {/* CTA 1 */}
          <div className="bg-slate-900 border border-slate-700 rounded-xl p-6 flex flex-col h-full hover:border-emerald-500/50 transition-colors" data-id="element-47">
            <h4 className="text-xl font-bold text-white mb-2" data-id="element-48">
              🥉 PACK BASE — $19.990
            </h4>
            <p className="text-sm text-amber-500 font-bold mb-2" data-id="element-49">
              6 Tomos + 3 Bonos
            </p>
            <p className="text-slate-400 text-sm mb-8 flex-grow italic" data-id="element-50">
              El conocimiento completo para profesionalizar tu empresa
            </p>
            <a href="https://fegion.shop/cart/46195221364875:1" className="w-full py-4 px-4 rounded-lg font-bold text-emerald-400 border-2 border-emerald-500 hover:bg-emerald-500/10 transition-colors block text-center" data-id="element-51">
              QUIERO EL PACK BASE →
            </a>
          </div>

          {/* CTA 2 */}
          <div className="bg-slate-900 border-2 border-emerald-500 rounded-xl p-6 flex flex-col h-full relative shadow-[0_0_30px_rgba(34,197,94,0.15)] transform md:-translate-y-4" data-id="element-52">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-emerald-500 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1 whitespace-nowrap" data-id="element-53">
              <StarIcon className="w-3 h-3 fill-current" data-id="element-54" /> MÁS ELEGIDO
            </div>
            <h4 className="text-xl font-bold text-white mb-2 mt-2" data-id="element-55">
              🥈 PACK IMPLEMENTACIÓN — $29.990
            </h4>
            <p className="text-sm text-emerald-400 font-bold mb-2" data-id="element-56">
              6 Tomos + 3 Bonos + Execution Toolkit
            </p>
            <p className="text-slate-400 text-sm mb-8 flex-grow italic" data-id="element-57">
              El conocimiento + las herramientas para implementar sin perder
              tiempo
            </p>
            <a href="https://fegion.shop/cart/46195232702603:1" className="w-full py-4 px-4 rounded-lg font-bold text-slate-900 bg-emerald-500 hover:bg-emerald-400 transition-colors shadow-lg shadow-emerald-500/30 block text-center" data-id="element-58">
              QUIERO EL PACK IMPLEMENTACIÓN
            </a>
          </div>

          {/* CTA 3 */}
          <div className="bg-slate-900 border-2 border-amber-500 rounded-xl p-6 flex flex-col h-full shadow-[0_0_30px_rgba(245,158,11,0.15)]" data-id="element-59">
            <h4 className="text-xl font-bold text-white mb-2" data-id="element-60">
              🥇 PACK CONTROL TOTAL — $39.990
            </h4>
            <p className="text-sm text-amber-500 font-bold mb-2" data-id="element-61">
              6 Tomos + 3 Bonos + Execution Toolkit + Governance System
            </p>
            <p className="text-slate-400 text-sm mb-8 flex-grow italic" data-id="element-62">
              El sistema completo para dirigir tu empresa con datos y libertad
              real
            </p>
            <a href="https://fegion.shop/cart/46195236503691:1" className="w-full py-4 px-4 rounded-lg font-bold text-slate-900 bg-gradient-to-r from-amber-400 to-amber-600 hover:from-amber-300 hover:to-amber-500 transition-colors shadow-lg shadow-amber-500/20 block text-center" data-id="element-63">
              QUIERO EL PACK CONTROL TOTAL →
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}